import './Selector.css'
import vases from '../assets/constants/vases.js';
import selectedVaseHighlight from '../assets/images/selectedVaseHighlight.png'
import React from "react"

function VaseSelector(props) {

    return (
                        <div className="displaysOnShelfDiv">
                        {vases.map((display, index) => (
                            <div className="vaseSelector" key={index}>
                                {console.log(display.name)}
                                {props.selectedDisplay === index &&
                                <img src={selectedVaseHighlight} alt="light beige glow showing this is the selected vase" className="selectedVaseHighlight" />
                                }
                                <img className="vaseDisplay" onClick={() => props.setSelectedDisplay(index)} src={display.src} alt={display.alt} />
                                <img className="vaseDisplay backVaseDisplay" src={display.backSrc} alt={display.alt} />
                            </div>
                        ))}
                    </div>
    )
}

export default VaseSelector;